import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/app/dashboard/DashboardPage';

export const Route = createFileRoute('/_admin/')({
  component: DashboardPage,
});
